import { Component, OnInit } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { JwtHelperService } from '@auth0/angular-jwt';
import { LoginService } from './services/login.service';

const jwtService = new JwtHelperService();

@Component({
  selector: 'app-root',
  imports: [ RouterOutlet, RouterModule ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {

  constructor(private loginService: LoginService) {}

  ngOnInit() {
    var jwtFromLocalStorage = localStorage.getItem("jwt");
    if (jwtFromLocalStorage) {
      const decodedToken = jwtService.decodeToken(jwtFromLocalStorage);
      var expireTime = new Date(decodedToken.exp * 1000);
      var currentTime = new Date();
      if (currentTime > expireTime) {
        // token is expired - remove it from local storage
        localStorage.removeItem("jwt");
      } else {
        // token is not expired.  Set the user.
        this.loginService.user.id = decodedToken.id;
        this.loginService.user.email = decodedToken.email;
        this.loginService.user.picture = decodedToken.picture;
        this.loginService.user.firstName = decodedToken.given_name;
        this.loginService.user.lastName = decodedToken.family_name;
        this.loginService.user.role = Number(decodedToken.role);
        this.loginService.loginSubject.next(this.loginService.user);
      }
    }
  }
}
